export default {
  'global#home': 'Inicio',
  'global#works': 'Obras',
  'global#date_human': 'Do MMMM YYYY',
  'global#layout_error_title': 'Spiacenti, si è verificato un errore',
  'global#layout_error_description': 'Prova a ricaricare la pagina tra qualche istante e se il problema persiste contatta l\'amministratore della piattaforma.',
  'global#facet_empty_text': 'Sin resultados',
  'readmore#label': 'Mostrar todo',
  'readmore#more': 'Leer más',
  'readmore#less': 'Leer menos',
  'search#title_works': 'Obras',
  'search#works_title': 'Mapping Chivalry <br>Proyecto Mambrino Base de Datos Bibliográfica (PMDB)',
  'search#title_bibliographies': 'Bibliografías',
  'search#maps_total': '<strong>{ total }</strong> Mapas',
  'search#editions_total': '<strong>{ total }</strong> Ediciónes',
  'search#samples_total': '<strong>{ total }</strong> Ejemplares',
  'search#maps_total_1': '<strong>{ total }</strong> Mapa',
  'search#maps_total_0': 'Sin mapa',
  'search#bibliographies_total': '<strong>{ total }</strong> Bibliografías',
  'search#bibliographies_total_1': '<strong>{ total }</strong> Bibliografía',
  'search#bibliographies_total_0': 'Sin bibliografía',
  'search#works_total': '<strong>{ total }</strong> Obras',
  'search#works_total_1': '<strong>{ total }</strong> Obra',
  'search#works_total_0': 'Sin obra',
  'search#placeholder_query': 'Buscar en titulos',
  'search#placeholder_types': 'Buscar en tipologías',
  'search#placeholder_authors': 'Buscar en autores',
  'search#header_types': 'Tipologías',
  'search#header_sources': 'Fuentes',
  'search#header_languages': 'Idiomas',
  'search#header_romances': 'Ciclos',
  'search#header_publishers': 'Editores',
  'search#header_places': 'Lugares',
  'search#header_subjects': 'Temas',
  'search#header_curators': 'Curadores',
  'search#header_cycles': 'Ciclos',
  'search#header_collocations': 'Localizaciónes',
  'search#header_authors': 'Autores',
  'search#header_dates': 'Años',
  'search#header_samples': 'Codigos',
  'search#title': 'Obras',
  'search#resultsamount': 'Resultados por página',
  'search#facets_title': 'Filtro de resultados',
  'search#filters_title': 'Filtros activos:',
  'search#sort_title': 'Ordenar',
  'search#sort_score': 'Orden por relevancia',
  'search#sort_asc': 'Orden alfabético (A→Z)',
  'search#sort_desc': 'Orden alfabético (Z→A)',
  'search#sort_data_desc': 'Más reciente',
  'search#fallback_text': 'No se han encontrado registros con estos parámetros de búsqueda. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#fallback_button': 'Cancelar la búsqueda',
  'search#ko_text': 'Oops, abbiamo riscontrato un errore nella ricerca. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#ko_button': 'Cancelar la búsqueda',
  'search#editions_title': 'Ediciones digitales',
  'search#news_total': '<strong>{ total }</strong> noticias',
  'search#news_total_0': 'No News',
  'search#characters_total': '<strong>{ total }</strong> Personajes',
  'search#characters_total_1': '<strong>{ total }</strong> Personaje',
  'search#motifs_title': 'Índice de motivos',
  'search#places_total_0': 'Sin lugar',
  'search#motifs_total': '<strong>{ total }</strong> Motivos',
  'search#motifs_total_1': '<strong>{ total }</strong> Motivo',
  'search#motifs_total_0': 'Sin Motivo',
  'search#places_total': '<strong>{ total }</strong> Lugares',
  'search#places_total_1': '<strong>{ total }</strong> Lugar',
  'search#characters_title': 'Índice  de personajes',
  'search#places_title': 'Indice dei Lugares',
  'search#header_traits': 'Rasgos',
  'search#header_keywords': 'Keywords',
  'search#header_works': 'Obras',
  'search#header_libraries': 'Biblioteca',
  'search#header_motif_type': 'Tipologie',
  'search#header_cities': 'Città',
  'search#header_forenames': 'Nomi',
  'search#header_in_works': 'Obras de aparición',
  'search#header_translators': 'Traductores',
  'search#sort_label_ciclo': 'Orden por posición en el ciclo',
  'search#description_button': 'Info',
  'search#description_link': 'Ok, ho capito',
  'search#redirect_link': 'Búsqueda avanzada',
  'resource#authors': 'de',
  'resource#date': 'publicado en',
  'resource#time_to_read': 'lectura de',
  'resource#metadata': 'metadatos',
  'resource#metadata_size': 'Dimensioni',
  'resource#collection-text': 'Edición digital',
  'resource#parent-record': 'Fuente',
  'resource#parent-edition': 'Edición',
  'resource#page_bibliographic_data': 'Obra > Datos bibliográficos',
  'resource#page_codicological_data': 'Obra > Datos codicológicos',
  'resource#page_composition_process': 'Obra > Proceso de composición',
  'resource#page_cited_bibliography': 'Obra > Bibliografía citada',
  'resource#collection-translations': 'Traducciones relacionadas',
  'resource#collection-sources': 'Fuentes relacionadas',
  'resource#collection-editions': 'Ediciónes',
  'resource#collection-samples': 'Ejemplares',
  'resource#collection-rewritings': 'Reescrituras',
  'resource#collection-antroponimi': 'Antropónimos relacionados',
  'resource#collection-toponimi': 'Toponimos relacionados',
  'resource#related_records': 'Fuentes relacionadas',
  'tabs#work_bibliographic_data': 'Datos bibliográficos',
  'tabs#work_codicological_data': 'Datos codicológicos',
  'tabs#work_composition_process': 'Proceso de composición',
  'tabs#work_cited_bibliography': 'Bibliografía citada',
  'resource#complete-title': 'Titolo completo',
  'resource#collection-digital-editions': 'Edizioni digitali',
  'resource#occurences': 'Occorrenze',
  'search#header_genres': 'Genere',
  'search#header_language': 'Lingua',
  'search#date': 'data',
  'search#biographies_total': '<strong>{ total }</strong> vite antiche',
  'search#biographies_total_1': '<strong>{ total }</strong> vita antica',
  'search#biographies_total_0': 'Nessuna vita antica',
  'search#title_biographies': 'Vite antiche',
  'search#iconographies_total': '<strong>{ total }</strong> iconografie',
  'search#iconographies_total_1': '<strong>{ total }</strong> iconografia',
  'search#iconographies_total_0': 'Nessuna iconografia',
  'search#title_iconographies': 'Vite antiche',
  'search#header_sex': 'Sesso',
  'search#tools_total': '<strong>{ total }</strong> materiali e strumenti',
  'search#tools_total_1': '<strong>{ total }</strong> materiale e strumento',
  'search#tools_total_0': 'Nessun materiale e strumento',
  'search#title_tools': 'Materiali e strumenti',
  'search#motif_placeholder_query': 'Cerca motivo',
  'advancedsearch#fulltext_text': 'Buscar en el portal (en todos los campos)',
  'advancedsearch#section_global': 'Busca en el portal',
  'advancedsearch#label_title': 'Título',
  'advancedsearch#reset': 'Limpiar los campos',
  'advancedsearch#submit': 'Buscar',
  'advancedsearch#label_bibliography': 'Bibliografía',
  'advancedsearch#label_author': 'Autor',
  'author.name': 'Autor',
  'advancedsearch#label_edition': 'Ediciones',
  'advancedsearch#label_date': 'Fecha',
  'advancedsearch#label_synopsis': 'Sinopsis',
  'advancedsearch#label_source': 'Fuentes caballerescas',
  'advancedsearch#filters_title': 'Filtros activos',
  'advancedsearch#section_work': 'Buscar las obras',
  'advancedsearch#section_edition': 'Buscar las ediciones',
  'advancedsearch#section_sample': 'Buscar en ejemplares',
  'advancedsearch#label_works': 'Obras',
  'advancedsearch#label_editions': 'Ediciones',
  'advancedsearch#label_samples': 'Ejemplares',
  'advancedsearch#label_translator': 'Traductor',
  'advancedsearch#label_place': 'Lugar de edición',
  'advancedsearch#label_cycle': 'Ciclo',
  'advancedsearch#label_subject': 'Sujeto',
  'advancedsearch#language': 'Idioma',
  'advancedsearch#label_editor': 'Editor',
  'advancedsearch#label_dedica': 'Dedicatario',
  'advancedsearch#label_year': 'Fecha',
  'advancedsearch#label_editorial-mark': 'Marca editorial',
  'advancedsearch#label_id_pmdb': 'ID PMDB',
  'advancedsearch#marginalia_label': 'Marginalia',
  'advancedsearch#reproduction_label': 'Reproducción fotográfica',
  'advancedsearch#digital_edition_label': 'Edición digital',
  'advancedsearch#value_exists': 'Sí',
  'advancedsearch#value_not_exists': 'No',
  'advancedsearch#label_library_city': 'Ciudad de la biblioteca',
  'advancedsearch#label_library': 'Biblioteca',
  'advancedsearch#label_note': 'Descripción y notas',
  'advancedsearch#label_previous_owner': 'Propietarios anteriores'

};
